import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "previously-uploaded" }
const _hoisted_2 = {
  class: "row",
  style: {"margin-bottom":"15px","display":"flex","gap":"15px"}
}
const _hoisted_3 = { style: {"display":"flex","gap":"15px"} }
const _hoisted_4 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_imdex_checkbox = _resolveComponent("imdex-checkbox")!
  const _component_imdex_radio = _resolveComponent("imdex-radio")!
  const _component_imdex_table = _resolveComponent("imdex-table")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", null, _toDisplayString(_ctx.$t(`import.prevUploadDialog.title`)), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`import.prevUploadDialog.subTitle`)), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_imdex_text_field, {
        value: _ctx.searchTerm,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        label: _ctx.$t(`import.prevUploadDialog.searchInputLabel`),
        "leading-icon": "fal fa-search"
      }, null, 8, ["value", "label"]),
      _createVNode(_component_imdex_select, {
        label: _ctx.$t(`import.prevUploadDialog.dateUploadedInputLabel`),
        value: _ctx.fileDateRange,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileDateRange) = $event)),
        items: _ctx.availableDateRanges
      }, null, 8, ["label", "value", "items"]),
      _createVNode(_component_imdex_select, {
        searchable: "",
        style: {"max-width":"250px"},
        value: _ctx.fileUploadedBy,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileUploadedBy) = $event)),
        label: _ctx.$t(`import.prevUploadDialog.uploaderInputLabel`),
        leadingIcon: "fal fa-search",
        items: _ctx.searchFileUsers
      }, null, 8, ["value", "label", "items"])
    ]),
    (!_ctx.tableLoading)
      ? (_openBlock(), _createBlock(_component_imdex_table, {
          key: 0,
          class: "prev-table",
          tableData: _ctx.previouslyUploadedTableData
        }, {
          "h-selected": _withCtx(() => []),
          "h-name": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`import.prevUploadDialog.tableHeadName`)), 1)
          ]),
          "h-uploaded": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`import.prevUploadDialog.tableHeadUploaded`)), 1)
          ]),
          "h-uploaded_by": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`import.prevUploadDialog.tableHeadUploadedBy`)), 1)
          ]),
          "h-size": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`import.prevUploadDialog.tableHeadSize`)), 1)
          ]),
          selected: _withCtx((prop) => [
            _createElementVNode("div", null, [
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_imdex_checkbox, {
                    key: 0,
                    value: prop.row.selected,
                    "onUpdate:value": ($event: any) => ((prop.row.selected) = $event)
                  }, null, 8, ["value", "onUpdate:value"]))
                : (_openBlock(), _createBlock(_component_imdex_radio, {
                    key: 1,
                    onClick: ($event: any) => (_ctx.selectedRow = prop.row.fileId),
                    value: prop.row.fileId == _ctx.selectedRow
                  }, null, 8, ["onClick", "value"]))
            ])
          ]),
          uploaded: _withCtx((prop) => [
            _createElementVNode("div", null, _toDisplayString(_ctx.moment(prop.row.uploaded).fromNow()), 1)
          ]),
          size: _withCtx((prop) => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatBytes(prop.row.size)), 1)
          ]),
          _: 1
        }, 8, ["tableData"]))
      : (_openBlock(), _createBlock(_component_imdex_spinner, {
          key: 1,
          size: "2",
          width: "30"
        })),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_imdex_btn, {
        disabled: _ctx.selectedFiles.length == 0,
        onClick: _ctx.confirmSelectedFiles,
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`import.prevUploadDialog.confirmBtn`)), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}